import { Lookup } from './lookup.interface';

export const IesWhoIsParent: { [name: string]: Lookup } = {
  me: {
    code: 'me',
    displayValue: 'Me',
    thirdPartyValue: '<<applicantName>>',
  },
  spousePartner: {
    code: 'spousePartner',
    displayValue: 'My current spouse/partner',
    thirdPartyValue: '<<spouseName>>',
  },
  dependentChild: {
    code: 'dependentChild',
    displayValue: 'My dependent child (choose if the parent of this child is also your dependent)',
    thirdPartyValue: 'My dependent child',
  },
};
